import { StatCard } from "@design-system/StatCard/StatCard";

type Props = {
  totalUsers?: number;
};

export const ResourceGroupTotalUsersStat = ({ totalUsers }: Props) => {
  return (
    <StatCard
      icon="faUser"
      title="Total users"
      value={totalUsers?.toString() ?? "0"}
    />
  );
};